import { Box, VStack, Text } from '@chakra-ui/react'
import { BrandBar } from '../../components/BrandBar'
import { TitleHeader } from '../../components/TitleHeader'
import { ReturnButton } from './ReturnButton'

export const PurchaseErrorMessage = ({ onReturnClick, onLogoClick }) => (
  <Box minH="100vh" bg="background.default" display="flex" justifyContent="center">
    <Box w="100%" maxW="500px">
      <VStack spacing={0} align="stretch">
        <BrandBar onLogoClick={onLogoClick} />
        <TitleHeader title="決済完了" />
        <Box py="40px" px="16px">
          <VStack spacing={6} align="center">
            <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
              購入情報が見つかりませんでした。
            </Text>
            <ReturnButton onClick={onReturnClick}>コイン購入画面に戻る</ReturnButton>
          </VStack>
        </Box>
      </VStack>
    </Box>
  </Box>
)
